// extracted by mini-css-extract-plugin
export default {"title":"head_title__7NvUB"};